import React, { Component } from 'react';
import './IndexComponent.scss';

class IndexComponent extends Component {
  render() {
    return (
      <>
        <div className="fb-container-1">
          <img
            src="logo/logo-demo-fb180.png"
            className="logo"
            alt="Feedback180"
          />
          <div className="fb-title">No content available.</div>
          <div className="sub-title">
            We couldn't find any relevant content for this page. Please visit
            for more information.
          </div>
        </div>
        <div className="footer-fb">
          <span>Powered by</span>
          <img
            src="icon-fb180.svg"
            className="power_by"
            alt="Powered by Feedback180"
          />
          <span> | Privacy Policy</span>
        </div>
      </>
    );
  }
}

export default IndexComponent;
